import React from 'react';
import { Link } from 'react-router-dom';
import BlogPost from '../Posts/BlogPost';
import getBlogData from '../../PostData/blogData';

const BlogSection = () => {
    const blogData = getBlogData.slice(0, 6);

    return (
        blogData.length !== 0 && <section id="latestBlog" className="latestBlog">
            <div className="container">
                <div className="text_center mbBig">
                    <h2 className="headingSecondary">Checkout My Latest Blog</h2>
                </div>

                <div className="blogWrap">
                    {blogData.map(blog => <BlogPost blogData={blog} key={blog.id}></BlogPost>)}
                </div> {/* Blog Wrap */}

                <div className="text_center"><Link to="/blog" className="btn btn-primary">Load More</Link></div>
            </div> {/* Container */}
        </section> // Latest Blog
    );
};

export default BlogSection;